import React, { useState, useEffect } from "react";
import { X, Cookie } from "lucide-react";

/**
 * Cookie & Analytics Notice Banner
 * Low-friction banner shown on first visit
 * No forced consent required for basic analytics
 */
const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already acknowledged the cookie notice
    const hasAcknowledged = localStorage.getItem("clarias-cookie-acknowledged");
    if (!hasAcknowledged) {
      // Show banner after a short delay
      const timer = setTimeout(() => setIsVisible(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcknowledge = () => {
    localStorage.setItem("clarias-cookie-acknowledged", "true");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-slide-up">
      <div className="bg-slate-900/95 backdrop-blur-sm border-t border-slate-700">
        <div className="max-w-6xl mx-auto px-4 py-3">
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-slate-700 flex items-center justify-center shrink-0">
                <Cookie className="w-4 h-4 text-slate-300" />
              </div>
              <p className="text-sm text-slate-300">
                CLARIAS uses cookies and analytics tools to improve platform performance and user experience.
              </p>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <button
                onClick={handleAcknowledge}
                className="px-4 py-1.5 bg-white text-slate-900 rounded-full text-sm font-medium hover:bg-slate-100 transition-colors"
              >
                Got it
              </button>
              <button
                onClick={handleAcknowledge}
                className="p-1.5 text-slate-400 hover:text-white transition-colors"
                aria-label="Close"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <style>{`
        @keyframes slide-up {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .animate-slide-up {
          animation: slide-up 0.3s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default CookieBanner;
